<bic-popup (close)="cancelClicked()" [title]="data.isFolder ? 'Ordner umbenennen?' : 'Datei umbenennen?'"
           customClass="w-[560px]">
  <div bicPopupContent [formGroup]="renameForm">
    <bic-input [errorCondition]="showValidationError" [formControlName]="'renameName'" [iconStart]="faPenToSquare"
               [label]="'Name'"
               [maxLength]="this.data.isFolder ? 32 : 100" [placeholder]="data.isFolder ? 'Ordnername * (erforderlich)' : 'Beispieldatei * (erforderlich)'" [required]="true" [showX]="false"
               class="w-full"></bic-input>
    @if (showValidationError) {
      <span class="block mt-2 text-sm text-red-500">{{ validationError }}</span>
    }
  </div>
  <div bicPopupButtonGroup class="flex flex-row w-full justify-end gap-4">
    <bic-button (onClick)="cancelClicked()" buttonType="white" textColor="gray">Abbrechen</bic-button>
    <bic-button (onClick)="renameClicked()" [disabled]="!isUniqueName()">Umbenennen</bic-button>
  </div>
</bic-popup>
